<template>
  <section class="vehicle-kpis" role="region" aria-labelledby="kpi-title">
    <div class="vehicle-kpis__header">
      <h2 id="kpi-title">KPIs rápidos</h2>
      <p class="muted">Resumen clave del vehículo y sus próximos hitos.</p>
    </div>

    <div v-if="loading" class="vehicle-kpis__grid">
      <div v-for="n in 5" :key="`kpi-skel-${n}`" class="vehicle-kpis__card">
        <div class="skeleton skeleton-line" style="width: 70%"></div>
        <div class="skeleton skeleton-line lg" style="width: 80%"></div>
        <div class="skeleton skeleton-line" style="width: 60%"></div>
      </div>
    </div>

    <div v-else class="vehicle-kpis__grid">
      <div v-for="kpi in kpis" :key="kpi.label" class="vehicle-kpis__card">
        <p class="vehicle-kpis__label">{{ kpi.label }}</p>
        <h3 :class="`tone-${kpi.tone || 'neutral'}`">{{ kpi.value }}</h3>
        <span class="vehicle-kpis__meta">{{ kpi.helper }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "VehicleKpis",
  props: {
    kpis: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.vehicle-kpis {
  display: grid;
  gap: 16px;
}

.vehicle-kpis__header h2 {
  margin: 0 0 6px;
}

.vehicle-kpis__header p {
  margin: 0;
}

.vehicle-kpis__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 14px;
}

.vehicle-kpis__card {
  background: var(--color-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 14px;
  display: grid;
  gap: 8px;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.vehicle-kpis__card:hover {
  transform: translateY(-2px);
  border-color: rgba(56, 189, 248, 0.4);
}

.vehicle-kpis__label {
  margin: 0;
  color: var(--muted);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.vehicle-kpis__card h3 {
  margin: 0;
  font-size: 18px;
}

.vehicle-kpis__meta {
  color: var(--muted);
  font-size: 12px;
}

.tone-success {
  color: var(--color-success);
}

.tone-warning {
  color: #fbbf24;
}

.tone-danger {
  color: var(--color-danger);
}

.tone-info {
  color: var(--color-accent);
}

.tone-neutral {
  color: var(--text);
}
</style>
